import Agency from './Agency';
import Mag from './Mag';
import ChildTemplate from '../_/ChildTemplate';

export default class extends ChildTemplate {
  type = 'mag';
  items = [];
  badge = false;
  show = false;
  news = null;


  adapters = {
    mag: new Mag(),
    agency: new Agency(),
  };

  get adapter() {
    return this.adapters[this.type];
  }

  init(data) {
    this.type = 'mag';
    if (data.IsSubAgent) {
      this.type = 'agency';
    }
    return this.adapter
      .init(data)
      .then(({ items, news }) => {
        this.items = items;
        this.badge = this.adapter.badge;
        if (news) {
          this.news = news;
          if (this.badge) {
            this.show = true;
          }
        }
      });
  }

  read() {
    return this.adapter
      .read()
      .then(() => {
        this.badge = false;
        this.show = false;
      });
  }
}
